import { OFFLINE_MODE_ENABLED } from '../core/config.js';
import { withDb } from './idb.js';
import { lwDispatch, lwOnce } from '../core/livewire.js';
import { renderScan } from '../ui/modal.js';

let _fetchAllInflight = null;

export const UNAVAILABLE = Symbol('UNAVAILABLE');

export async function serverFetchAllBadges() {
    if (_fetchAllInflight) return _fetchAllInflight; // dedupe

    _fetchAllInflight = (async () => {
        const p = lwOnce('checkin.badges.initial.fetched');
        lwDispatch('checkin.badges.initial.fetch');
        const { badges = [] } = await p;
        return badges;
    })();

    try {
        return await _fetchAllInflight;
    } finally {
        _fetchAllInflight = null;
    }
}

export async function serverFetchBadge(uuid) {
    const p = lwOnce('checkin.badge.server.fetched');
    lwDispatch('checkin.badge.server.fetch', { badge_uuid: uuid });
    const { badge = null } = await p;
    return badge;
};

export async function withStorage(fn, fallbackServerFn, { offlineMessage = 'Local DB not available. This page can only work with the device online.', notify = true } = {}) {
    // If offline mode is disabled, prioritize server when online
    if (!OFFLINE_MODE_ENABLED) {
        if (navigator.onLine) {
            return await fallbackServerFn();
        }
    }

    // Offline mode enabled → try IDB first
    try {
        const val = await withDb(fn);
        return val;
    } catch (err) {
        console.warn('[checkin] DB unavailable, falling back.', err);
        if (navigator.onLine) {
            try { return await fallbackServerFn(); }
            catch { /* fall through */ }
        }
        if (notify) renderScan?.({ status: 'danger', message: offlineMessage, allowProceed: false });
        return UNAVAILABLE;
    }
};

export async function getBadge(uuid) {
    const res = await withStorage(
        db => db.get('badges', uuid),
        () => serverFetchBadge(uuid),
        { offlineMessage: 'Local DB not available. This page can only work with the device online.' }
    );
    if (res === UNAVAILABLE) return UNAVAILABLE;
    return res || null;
};
